/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
/** Common Components */
import Buttons from '../../../../components/ui/button/Buttons';

/** Common Services & Data Files */
import ToastService from '../../../../services/toastService/ToastService';
import { AppIcons } from '../../../../data/appIcons';

/** RTK Query */
import { useAddProjectDefaultStatusMutation } from '../../../../app/services/projectStatusAPI';

/** Lazily Loaded Component */
import { useLazyGetAllTaskStatusQuery } from '../../../../app/services/taskStatusAPI';

const AddDefaultStatus = (props) => {
  const ProjectId = props.projectId;
  /* State*/
  const [taskStatusData, setTaskStatusData] = useState([]);
  const [selectedTaskStatuses, setSelectedTaskStatuses] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  // API'S Call
  const [getAllTaskStatus, {
    data: ProjectData
  }] = useLazyGetAllTaskStatusQuery();

  const [addProjectDefaultStatus, {
    isSuccess: isDefaultStatusSuccess,
    data: defaltStatusData
  }] = useAddProjectDefaultStatusMutation();

  //** Funcation's */
  const backToList = () => {
    props.onClose();
  };

  const handleCheckboxChange = (taskStatusId) => {
    setSelectedTaskStatuses((prevSelected) =>
      prevSelected.includes(taskStatusId)
        ? prevSelected.filter((id) => id !== taskStatusId)
        : [...prevSelected, taskStatusId]
    );
  };

  const handleSubmit = async () => {
    const selectedTaskStatus = selectedTaskStatuses.join(', ');
    const payload = {
      projectId: ProjectId,
      // statusName: change,
      selectedTaskStatusId: selectedTaskStatus
    };
    addProjectDefaultStatus(payload);
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedTaskStatuses([]);
    } else {
      setSelectedTaskStatuses(taskStatusData.map((status) => status.taskStatusId));
    }
    setSelectAll(!selectAll);
  };

  /** useEffects */
  useEffect(() => {
    getAllTaskStatus();
  }, [getAllTaskStatus]);

  useEffect(() => {
    if (ProjectData) {
      setTaskStatusData(ProjectData);
    }
  }, [ProjectData]);

  useEffect(() => {
    if (isDefaultStatusSuccess && defaltStatusData) {
      if (defaltStatusData.errorMessage.includes("exists")) {
        ToastService.warning(defaltStatusData.errorMessage);
        return;
      } else {
        ToastService.success(defaltStatusData.errorMessage);
        backToList();
        const request = {
          pagination: {
            pageNumber: 1,
            pageSize: 40,
          },
          filters: { searchText: "" },
        };
        props.getProjectDataList(request)
      }
    }
  }, [isDefaultStatusSuccess, defaltStatusData])

  return (
    <>
      <form>
        <div className="row">
          <div className="checkbox-label-part">
            <input
              className="checkbox"
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            <span>Select All</span>
          </div>
          {taskStatusData.map((status) => (
            <div className='checkbox-label-part' key={status.taskStatusId}>
              {/* <Checkbox label={props.label} onChange={props.onChange} name={props.name}/> */}
              <input className='checkbox'
                type="checkbox"
                checked={selectedTaskStatuses.includes(status.taskStatusId)}
                onChange={() => handleCheckboxChange(status.taskStatusId)}
              />
              <span>{status.statusName}</span>
            </div>
          ))}
        </div>
      </form>
      <div className="row">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={backToList}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              onClick={handleSubmit}
              buttonText={"Take Over"}
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </>
  )
}

AddDefaultStatus.propTypes = {
  onClose: PropTypes.func.isRequired,
};
export default AddDefaultStatus;